import type { ActionType } from '@components/table/types.ts';

export const ACTION_TYPES = {
    ResettedDefault: 'ResettedDefault',
    Published: 'Published',
    Deleted: 'Deleted',
    Edited: 'Edited',
    Deactivated: 'Deactivated',
    Activated: 'Activated',
    Draft: 'Draft',
    Archive: 'Archive',
    ReActivated: 'ReActivated',
    RePublished: 'RePublished',
    AutoDeactivated: 'AutoDeactivated',
} as const satisfies Record<string, ActionType>;
